import { observer } from 'mobx-react-lite';
import { useEffect, useState } from 'react';
import assetImportService from '@backgroundTasks/services/AssetsImportService';

import assetDownloadService from '../../services/AssetDownloadService';

import BackgroundTasksBox from './BackgroundTasksBox';

const BackgroundTasksBoxDisplayer = () => {
	const [ displayBox, setDisplayBox ] = useState( false );
	const { hasUnfinishedDownloads } = assetDownloadService;
	const { hasUnfinishedImports } = assetImportService;

	useEffect( () => {
		if ( hasUnfinishedDownloads || hasUnfinishedImports ) setDisplayBox( true );
	}, [ hasUnfinishedDownloads, hasUnfinishedImports ] );

	return displayBox
		? (
			<BackgroundTasksBox
				assetDownloadService={assetDownloadService}
				assetImportService={assetImportService}
				onBoxClosed={() => setDisplayBox( false )}
			/>
		)
		: <div />;
}

export default observer( BackgroundTasksBoxDisplayer );
